<ol *ngIf="breadcrumbList && breadcrumbList.length > 1">
	<li
		class="obg-compact-breadcrumb-item"
		*ngFor="let item of breadcrumbList; first as isFirst; last as isLast; trackBy: trackByItem"
	>
		<ng-container *ngIf="isFirst || isLast; else link">
			<ng-container *ngIf="isFirst">
				<a [obgRouteLink]="{ url: item.route }">{{ item.label | translate | lowercase }}</a>
				<span class="ico-chevron-right"></span>
			</ng-container>
			<span *ngIf="isLast">{{ item.label }}</span>
		</ng-container>
		<ng-template #link>
			<a [obgRouteLink]="{ url: item.route }">{{ item.label }}</a>
			<span class="ico-chevron-right"></span>
		</ng-template>
	</li>
</ol>
